import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllMPStainlessSteelTables = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.MP_STAIN_STEEL_TABLE}`, {
        params: { page, size, search: searchString },
    });
    return response.data;
};